import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, inject } from '@angular/core';
import { signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';
import { DashboardComponent } from 'src/app/profiles/dashboard/dashboard.component';
import { ProfileWrapperComponent } from 'src/app/profiles/profile-wrapper/profile-wrapper.component';

export interface crumbtrailItem {
  text:string,
  rcl:number|any
}


@Injectable({
  providedIn: 'root',
})
export class CrumbtrailService {

  constructor() { }

  private http: HttpClient = inject(HttpClient)

  public crumbtrailContent = signal<crumbtrailItem[] | undefined>(undefined);


  setCrumbtrailContent(content:crumbtrailItem[]) {
    this.crumbtrailContent.set(content)

    // console.log(this.crumbtrailContent())
  }

  loadCrumbtrail() {
    // Example async loading
    this.crumbtrailContent.set([
      { text: 'Retailers', rcl: null },
      { text: 'Amazon', rcl: null }
    ]);
  }

}
